export default __webpack_public_path__ + "static/fonts/BodoniW01Book.6b15571.woff2";